import React from 'react';
import { Button, Col, UncontrolledTooltip } from 'reactstrap';
import DeleteIcon from '@mui/icons-material/DeleteOutlineOutlined';
import AddIcon from '@mui/icons-material/AddOutlined';
import SearchIcon from '@mui/icons-material/Search';

class GridHeader extends React.Component {

    render() {

        const { gridEntities,
            customHeaderButton,
            deleteButtonId,
            disableDelete,
            disableAdd = false,
            onDeleteClick,
            addButtonId,
            onAddClick,
            tooltipEntity,
            searchButtonId,
            showSearch,
            showDeleteButton = true,
            onSearch } = this.props;

        const toolTipToDisplay = tooltipEntity ? `Add a new ${tooltipEntity}` : 'Activate Contact'

        return (
            <React.Fragment>
                <Col className="d-flex align-items-center">
                    {/* Align title and custom header next to each other */}
                    <h3 className="mb-0 me-2">{gridEntities}</h3>
                    {customHeaderButton}
                </Col>
                <Col className='d-flex flex-row-reverse'>
                    {showDeleteButton && <Button id={deleteButtonId} disabled={disableDelete} onClick={onDeleteClick}><DeleteIcon /></Button>}
                    <Button
                        id={addButtonId}
                        disabled={disableAdd}
                        onClick={onAddClick}
                        style={{
                            backgroundColor: 'green',
                            color: 'white',
                            width: '8em',
                            fontColor: 'white'
                        }}
                        className="me-1"
                    >
                    Add New +
                    </Button>
                    {showSearch &&
                        <React.Fragment>
                            <Button id={searchButtonId} onClick={onSearch} className='me-1'><SearchIcon /></Button>
                            <UncontrolledTooltip delay={{ show: 0, hide: 0 }} target={searchButtonId}>Search {tooltipEntity}s.</UncontrolledTooltip>
                        </React.Fragment>
                    }

                    <UncontrolledTooltip delay={{ show: 0, hide: 0 }} target={addButtonId}>{toolTipToDisplay}.</UncontrolledTooltip>
                    {deleteButtonId && <UncontrolledTooltip delay={{ show: 0, hide: 0 }} target={deleteButtonId}>Delete {tooltipEntity}s.</UncontrolledTooltip>}
                </Col>
            </React.Fragment>
        )
    }
}

export default GridHeader;
